export default {
  NUMBER_INPUT_DECIMALS: 3,
  NO_UNIT_CHAR: '-',
  POPUP_DELAY_MED: 500,
}
